<template>
  <base-page
    v-bind:schemaName="'productCategory'"
    v-bind:isHideRemove="true"
    v-model:entity="entity"
  >
    <template v-slot:panel-left="{ entity }">
      <div class="mb-3 text-left">
        <label class="form-label">{{ fieldLabel("name", "Назва") }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.name"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{ fieldLabel("sheetLink", "Ідентифікатор таблиці") }}</label>
        <input class="form-control" v-model="entity.sheetLink" required />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{ fieldLabel("code", "Код") }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.code"
          required
        />
      </div>
    </template>
  </base-page>
</template>

<script>
import BasePage from "@/components/Sections/BasePage.vue";
export default {
  name: "CaregoryPage",
  components: { BasePage },
  data() {
    return {
      entity: {},
    };
  },
  methods: {
    fieldLabel(field, fallback) {
      return this.$filters.localize(`ProductCategoryPage.fields.${field}`) || fallback;
    },
  },
};
</script>
<style scoped>
.image-size {
  max-height: 300px;
  width: 300px;
}
</style>
